import { CartButtonProps } from "@omni/types/components/props/cartButton.props";
import { BaseStore } from "@omni/types/enums/baseStore.enum";
import { ReactNode, useState } from "react";
import { useSelector } from "react-redux";

import { CartButtonContextProvider } from "@/components/Navigation/Buttons/CartButton/context/cartButton.context";
import { useCartItemsCount } from "@/components/Navigation/Buttons/CartButton/hooks/useCartItemsCount.hook";
import { useThunkDispatch } from "@/redux/dispatcher";
import * as CartModule from "@/redux/modules/api/data/cart/cart.module";
import * as CartSelectors from "@/redux/modules/api/data/cart/cart.selectors";
import {
    useIsBreakpoint,
    withBreakpoints
} from "@/utils/breakpoints/breakpoints.provider";

type Props = CartButtonProps<BaseStore> & {
    children: ReactNode;
};

const _Base = ({
    icon,
    text,
    ariaLabel,
    invert,
    link,
    invertMobile,
    textHidden,
    redirect,
    children
}: Props) => {
    const { count } = useCartItemsCount();

    const [isUpdatingCart, setIsUpdatingCart] = useState({});
    const [activeId, setActiveId] = useState("");
    const cart = useSelector(CartSelectors.getCart);
    const dispatch = useThunkDispatch();

    const { matches: isLarge } = useIsBreakpoint("lg");

    const handleRemoveFromCart = (
        id: string,
        quantity: number,
        free: boolean
    ) => {
        setActiveId(id);
        setIsUpdatingCartForId(id, true);
        dispatch(CartModule.removeFromCart(id, quantity, free)).then(() =>
            setIsUpdatingCartForId(id, false)
        );
    };

    const setIsUpdatingCartForId = (id: string, isUpdatingCart: boolean) => {
        setIsUpdatingCart((cur: any) => ({
            ...cur.isUpdatingCart,
            [id]: isUpdatingCart
        }));
    };

    const alert = count ? (count < 100 ? count.toString() : "+99") : undefined;

    return (
        <CartButtonContextProvider
            headerButtonProps={{
                icon: icon,
                text: text,
                ariaLabel: ariaLabel,
                invert: invert,
                invertMobile: invertMobile,
                hover: isLarge,
                link: cart?.items?.length ? redirect : link,
                alerts: alert,
                withOverlay: !isLarge,
                textHidden: textHidden,
                iconPrefix: "las tw:text-4xl!"
            }}
            redirect={redirect}
            cart={cart}
            isUpdatingCart={isUpdatingCart}
            activeId={activeId}
            onRemoveFromCart={handleRemoveFromCart}
        >
            {children}
        </CartButtonContextProvider>
    );
};

export const Base = withBreakpoints(_Base);
